module.exports = __webpack_public_path__ + "img/qx_station_2u.a74b7d56.png";